import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import {styled} from '@mui/material/styles';

export const StyledSectionContentContainer = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  position: 'relative'
}));

export const StyledPointsChip = styled(Chip)(({theme}) => ({
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(1),
  borderColor: theme.palette.grey[300],
  fontSize: theme.typography.button.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.caption.fontSize
  }
}));

export const StyledBodyWrapper = styled(Box)<{loading?: boolean}>(({theme, loading}) => ({
  width: '100%',
  height: '100vh',
  overflowY: loading ? 'hidden' : 'auto',
  backgroundColor: theme.palette.grey[50],
  position: 'relative'
}));
